export const getBookingWizardModalProps = (isConfirmStep) => ({
  contentPadding: '24px 24px 16px',
  elevated: isConfirmStep,
  dialogMaxWidth: '460px'
});

export const AMENITY_ADD_WIZARD_MODAL_PROPS = {
  contentPadding: '32px 24px'
};

export const AMENITY_FLUSH_MODAL_PROPS = {
  contentPadding: '0',
  footerPadding: '20px 20px 40px',
  footerStacked: true
};

export const BOOKING_DETAIL_MODAL_PROPS = {
  contentPadding: '0',
  footerPadding: '20px 20px 40px',
  footerStacked: true
};
